import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface UpdateVideoStatusInterface {
  vid: string;
  status: string;
}

export const useUpdateVideoStatus = () => {
  const mutate = useMutation(({ vid, status }: UpdateVideoStatusInterface) => {
    return postAPI('/external-api/update_video_status', {
      vid,
      status,
    });
  });

  return mutate;
};

export default useUpdateVideoStatus;
